export default "__VITE_ASSET__DkWK9ti___"